import React, { Fragment } from "react";
import { CSVLink } from "react-csv";
import Button from '@material-ui/core/Button';
import ButtonContent from './ButtonContent';

export default class DownloadUserCSVButton extends React.Component {
  constructor(props) {
      super(props);
      this.state = {
        listOfUsers: [],
        loading: false
      };
      this.csvlink = React.createRef();
  }

  download = (event) => {
    if(!this.state.loading) {
      this.setState({
        loading: true
      });
      this.props.downloadPartners(this.props.isReferUser).then((res) => {
        let partners = Object.values(res).map((partner) => {
            let user = partner.user ? partner.user : partner;
            return {
              firstName: user.firstName,
              lastName: user.lastName,
              email: user.email
            }
         })
        this.setState({
          listOfUsers: partners,
          loading: false
        }, () => {
          this.csvlink.link.click()
        });
      }).catch(() => {
        this.setState({
          loading: false
        });
      });
    }
  }

  dataFromListOfUsersState = () => {
    return this.state.listOfUsers;
  }

  render() {

    const { loading } = this.state;
    const headers = [{
      key: 'firstName',
      label: 'First Name'
    }, {
      key: 'lastName',
      label: 'Last Name'
    }, {
      key: 'email',
      label: 'Email'
    }];

    return(
      <Fragment>
          <Button
              variant="contained"
              color="primary" onClick={this.download}>
              <ButtonContent
                text= {this.props.btnText } />
            </Button>
          <CSVLink
              data={this.state.listOfUsers}
              ref={(r) => this.csvlink = r}
              target='_blank'
              filename={this.props.isReferUser ? 'appusers.csv' : 'members.csv'}
              headers = {headers}
            >
          </CSVLink>
      </Fragment>)
  }
}


// WEBPACK FOOTER //
// ./src/components/DownloadCSV.js